<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" title="头像审核" center width="600px" :before-close="$onClose" destroy-on-close @close="close()">
      <div>
        <el-image style="width: 200px; height: 200px; float: left" fit="contain" :src="urlPath + info.img_link"></el-image>
        <div class="user_info">
          <p>
            <span>姓名&nbsp;</span>
            {{ info.name }}
          </p>
          <p style="margin-top: 10px">
            <span>学号&nbsp;</span>
            {{ info.student_no }}
          </p>
          <p style="margin-top: 10px">
            <span>提交时间&nbsp;</span>
            {{ info.createTime }}
          </p>
        </div>
      </div>

      <div class="footDialog">
        <el-button style="width: 106px; float: right" size="small" type="primary" v-preventReClick @click="pass()">通过审核</el-button>
        <el-button style="width: 106px; float: right; margin-right: 15px" size="small" v-preventReClick @click="refuse()">拒绝审核</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
import { isEmpty } from '@/utils/strUtils'
import preventReClick from '@/utils//preventReClick' //防多次点击，重复提交
import * as Constant from '@/utils/constant.js'

export default {
  data() {
    return {
      urlPath: URL_PATH,
      changVisible: false,
      info: { student_no: '', name: '', img_link: '', createTime: '' }
    }
  },
  methods: {
    $onClose(done) {
      done()
    },
    close() {
      this.changVisible = false
    },
    //页面初始化时加载的事件
    show(info) {
      this.info = info
      this.changVisible = true
    },
    pass: function () {
      this.$emit('saveData', [this.info.id], 'Y')
      this.close()
    },
    refuse: function () {
      this.$emit('showRefuseDialog', [this.info.id])
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
.user_info {
  float: left;
  margin-left: 30px;
}
.user_info p span {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/photoExamineDialog.vue